import React, { Component } from 'react';
class Counter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count: props.duration || 300, 
            interval: props.interval || 1000,
        };
    }
    componentDidMount() {
        this.startCounter();
    }
    componentWillUnmount() {
        clearInterval(this.counterInterval); 
    }
    updateCounter = () => {
        this.setState(prevState => ({
            count: prevState.count <= 0 ? this.props.duration || 300 : prevState.count - 1 
        }), () => {
            if (this.state.count === 0 && this.props.onCounterComplete) {
                this.props.onCounterComplete(); 
            }
        });
    };
    startCounter = () => {
        this.counterInterval = setInterval(() => {
            this.updateCounter();
        }, this.state.interval);
    };
    render() {
        return (
            <div>
               <h5 style={{ fontWeight: 600,  padding: 5 }}>The Page will referesh in <span style={{color:'red'}}> {this.state.count} </span>seconds</h5> 
            </div>
        );
    }
}

export default Counter;
